import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectSearchQueryVariables = Types.Exact<{
  asOf?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  searchText?: Types.InputMaybe<Types.Scalars['String']>;
  projectNumbers?: Types.InputMaybe<Array<Types.Scalars['Int']> | Types.Scalars['Int']>;
  token?: Types.InputMaybe<Types.Scalars['String']>;
  billingAdmin?: Types.InputMaybe<Types.Scalars['String']>;
  projectManager?: Types.InputMaybe<Types.Scalars['String']>;
  projectSupervisor?: Types.InputMaybe<Types.Scalars['String']>;
  officeCode?: Types.InputMaybe<Types.Scalars['String']>;
  customerNumber?: Types.InputMaybe<Types.Scalars['String']>;
  projectType?: Types.InputMaybe<Types.Scalars['String']>;
  division?: Types.InputMaybe<Types.Scalars['String']>;
  corpLocation?: Types.InputMaybe<Types.Scalars['String']>;
  dateInEqual?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  dateInBefore?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  dateInAfter?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  state?: Types.InputMaybe<Types.Scalars['String']>;
  county?: Types.InputMaybe<Types.Scalars['String']>;
  afeWoPo?: Types.InputMaybe<Types.Scalars['String']>;
  status?: Types.InputMaybe<Types.ProjectSearchStatus>;
  clientContactName?: Types.InputMaybe<Types.Scalars['String']>;
  sortBy?: Types.InputMaybe<Types.ProjectSortBy>;
  projectGroupArgs?: Types.InputMaybe<Types.ProjectGroupArgsInput>;
  certifiedPayroll?: Types.InputMaybe<Types.Scalars['Boolean']>;
  industry?: Types.InputMaybe<Types.Scalars['String']>;
  serviceDescription?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ProjectSearchQuery = { __typename?: 'QueryModel', projects?: { __typename?: 'ProjectsQueryModelOld', search?: { __typename?: 'ConnectionOfProject', token?: string | null, records?: Array<{ __typename?: 'Project', allowThirdPartyInvoice: boolean, name: string, number: number, actualStartDate?: string | null, actualEndDate?: string | null, officeCode: string, clientContactName: string, estimatedStartDate?: string | null, estimatedEndDate?: string | null, governmentFunding: Types.GovernmentFundingType, afe?: string | null, budget?: number | null, section?: string | null, township?: string | null, range?: string | null, block?: string | null, survey?: string | null, internalNotes: string, invoiceNotes: string, geographicLocation: string, dateIn: string, status: Types.ProjectStatus, certifiedPayroll: boolean, projectOrigination?: Types.ProjectOrigination | null, projectOriginationName?: string | null, customer?: { __typename?: 'Customer', name: string, number?: string | null } | null, stats?: { __typename?: 'ProjectStats', chargesAwaitingApproval: number, chargesBilled: number, chargesPendingBilling: number, chargesUnbilled: number, chargesUnreviewed: number, totalPendingHours: number } | null, expenseRateSheets?: Array<{ __typename?: 'ExpenseRateSheetAssignment', effectiveDate: string, rateSheet?: { __typename?: 'ExpenseRateSheet', name: string } | null } | null> | null, taskRateSheets?: Array<{ __typename?: 'TaskRateSheetAssignment', effectiveDate: string, rateSheet?: { __typename?: 'TaskRateSheet', name: string } | null } | null> | null, projectSupervisor?: { __typename?: 'Employee', firstName: string, lastName: string } | null, projectManager?: { __typename?: 'Employee', firstName: string, lastName: string } | null, billingAdmin?: { __typename?: 'Employee', firstName: string, lastName: string } | null, corpLocation?: { __typename?: 'CorpLocation', name: string, id: string } | null, division?: { __typename?: 'Division', id: string, name: string } | null, serviceDescription?: { __typename?: 'ServiceDescription', displayName: string, industry: string, description: string, projectType: string, isOverhead: boolean, legacyWorkCode: string } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null, eogAfeType?: { __typename?: 'EogAfeType', gen: string, sub: string, description: string, afeType: string } | null, projectGroup?: { __typename?: 'ProjectGroup', name: string } | null } | null> | null } | null } | null };

export type ProjectSearchWithStatsQueryVariables = Types.Exact<{
  asOf?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  searchText?: Types.InputMaybe<Types.Scalars['String']>;
  projectNumbers?: Types.InputMaybe<Array<Types.Scalars['Int']> | Types.Scalars['Int']>;
  token?: Types.InputMaybe<Types.Scalars['String']>;
  billingAdmin?: Types.InputMaybe<Types.Scalars['String']>;
  projectManager?: Types.InputMaybe<Types.Scalars['String']>;
  projectSupervisor?: Types.InputMaybe<Types.Scalars['String']>;
  officeCode?: Types.InputMaybe<Types.Scalars['String']>;
  customerNumber?: Types.InputMaybe<Types.Scalars['String']>;
  projectType?: Types.InputMaybe<Types.Scalars['String']>;
  division?: Types.InputMaybe<Types.Scalars['String']>;
  corpLocation?: Types.InputMaybe<Types.Scalars['String']>;
  dateInEqual?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  dateInBefore?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  dateInAfter?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  state?: Types.InputMaybe<Types.Scalars['String']>;
  county?: Types.InputMaybe<Types.Scalars['String']>;
  afeWoPo?: Types.InputMaybe<Types.Scalars['String']>;
  status?: Types.InputMaybe<Types.ProjectSearchStatus>;
  clientContactName?: Types.InputMaybe<Types.Scalars['String']>;
  sortBy?: Types.InputMaybe<Types.ProjectSortBy>;
  projectGroupArgs?: Types.InputMaybe<Types.ProjectGroupArgsInput>;
  certifiedPayroll?: Types.InputMaybe<Types.Scalars['Boolean']>;
  industry?: Types.InputMaybe<Types.Scalars['String']>;
  serviceDescription?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ProjectSearchWithStatsQuery = { __typename?: 'QueryModel', projects?: { __typename?: 'ProjectsQueryModelOld', search?: { __typename?: 'ConnectionOfProject', token?: string | null, records?: Array<{ __typename?: 'Project', name: string, number: number, clientContactName: string, actualStartDate?: string | null, actualEndDate?: string | null, officeCode: string, estimatedStartDate?: string | null, estimatedEndDate?: string | null, governmentFunding: Types.GovernmentFundingType, afe?: string | null, budget?: number | null, section?: string | null, township?: string | null, range?: string | null, block?: string | null, survey?: string | null, internalNotes: string, invoiceNotes: string, geographicLocation: string, dateIn: string, status: Types.ProjectStatus, certifiedPayroll: boolean, projectOrigination?: Types.ProjectOrigination | null, projectOriginationName?: string | null, customer?: { __typename?: 'Customer', name: string, number?: string | null } | null, stats?: { __typename?: 'ProjectStats', chargesAwaitingApproval: number, chargesBilled: number, chargesPendingBilling: number, chargesUnbilled: number, chargesUnreviewed: number, totalPendingHours: number } | null, expenseRateSheets?: Array<{ __typename?: 'ExpenseRateSheetAssignment', effectiveDate: string, rateSheet?: { __typename?: 'ExpenseRateSheet', name: string } | null } | null> | null, taskRateSheets?: Array<{ __typename?: 'TaskRateSheetAssignment', effectiveDate: string, rateSheet?: { __typename?: 'TaskRateSheet', name: string } | null } | null> | null, projectSupervisor?: { __typename?: 'Employee', firstName: string, lastName: string } | null, projectManager?: { __typename?: 'Employee', firstName: string, lastName: string } | null, billingAdmin?: { __typename?: 'Employee', firstName: string, lastName: string } | null, corpLocation?: { __typename?: 'CorpLocation', name: string, id: string } | null, division?: { __typename?: 'Division', id: string, name: string } | null, serviceDescription?: { __typename?: 'ServiceDescription', displayName: string, industry: string, description: string, projectType: string, isOverhead: boolean, legacyWorkCode: string } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null, eogAfeType?: { __typename?: 'EogAfeType', gen: string, sub: string, description: string, afeType: string } | null, projectGroup?: { __typename?: 'ProjectGroup', name: string } | null } | null> | null } | null, stats?: { __typename?: 'ProjectSearchStats', projectCount: number } | null } | null };


export const ProjectSearchDocument = gql`
    query ProjectSearch($asOf: LocalDate, $searchText: String, $projectNumbers: [Int!], $token: String, $billingAdmin: String, $projectManager: String, $projectSupervisor: String, $officeCode: String, $customerNumber: String, $projectType: String, $division: String, $corpLocation: String, $dateInEqual: LocalDate, $dateInBefore: LocalDate, $dateInAfter: LocalDate, $state: String, $county: String, $afeWoPo: String, $status: ProjectSearchStatus, $clientContactName: String, $sortBy: ProjectSortBy, $projectGroupArgs: ProjectGroupArgsInput, $certifiedPayroll: Boolean, $industry: String, $serviceDescription: String) {
  projects {
    search(
      asOf: $asOf
      searchText: $searchText
      projectNumbers: $projectNumbers
      token: $token
      billingAdmin: $billingAdmin
      projectManager: $projectManager
      projectSupervisor: $projectSupervisor
      officeCode: $officeCode
      customerNumber: $customerNumber
      projectType: $projectType
      division: $division
      corpLocation: $corpLocation
      dateInEqual: $dateInEqual
      dateInBefore: $dateInBefore
      dateInAfter: $dateInAfter
      state: $state
      county: $county
      afeWoPo: $afeWoPo
      status: $status
      clientContactName: $clientContactName
      sortBy: $sortBy
      projectGroupArgs: $projectGroupArgs
      certifiedPayroll: $certifiedPayroll
      industry: $industry
      serviceDescription: $serviceDescription
    ) {
      token
      records {
        allowThirdPartyInvoice
        name
        number
        customer {
          name
          number
        }
        actualStartDate
        actualEndDate
        stats {
          chargesAwaitingApproval
          chargesBilled
          chargesPendingBilling
          chargesUnbilled
          chargesUnreviewed
          totalPendingHours
        }
        expenseRateSheets {
          rateSheet {
            name
          }
          effectiveDate
        }
        taskRateSheets {
          rateSheet {
            name
          }
          effectiveDate
        }
        officeCode
        clientContactName
        projectSupervisor {
          firstName
          lastName
        }
        projectManager {
          firstName
          lastName
        }
        billingAdmin {
          firstName
          lastName
        }
        estimatedStartDate
        estimatedEndDate
        corpLocation {
          name
          id
        }
        division {
          id
          name
        }
        serviceDescription {
          displayName
          industry
          description
          projectType
          isOverhead
          legacyWorkCode
        }
        governmentFunding
        location {
          state
          county
        }
        afe
        eogAfeType {
          gen
          sub
          description
          afeType
        }
        budget
        section
        township
        range
        block
        survey
        internalNotes
        invoiceNotes
        geographicLocation
        dateIn
        status
        certifiedPayroll
        projectGroup {
          name
        }
        projectOrigination
        projectOriginationName
      }
    }
  }
}
    `;

/**
 * __useProjectSearchQuery__
 *
 * To run a query within a React component, call `useProjectSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectSearchQuery({
 *   variables: {
 *      asOf: // value for 'asOf'
 *      searchText: // value for 'searchText'
 *      projectNumbers: // value for 'projectNumbers'
 *      token: // value for 'token'
 *      billingAdmin: // value for 'billingAdmin'
 *      projectManager: // value for 'projectManager'
 *      projectSupervisor: // value for 'projectSupervisor'
 *      officeCode: // value for 'officeCode'
 *      customerNumber: // value for 'customerNumber'
 *      projectType: // value for 'projectType'
 *      division: // value for 'division'
 *      corpLocation: // value for 'corpLocation'
 *      dateInEqual: // value for 'dateInEqual'
 *      dateInBefore: // value for 'dateInBefore'
 *      dateInAfter: // value for 'dateInAfter'
 *      state: // value for 'state'
 *      county: // value for 'county'
 *      afeWoPo: // value for 'afeWoPo'
 *      status: // value for 'status'
 *      clientContactName: // value for 'clientContactName'
 *      sortBy: // value for 'sortBy'
 *      projectGroupArgs: // value for 'projectGroupArgs'
 *      certifiedPayroll: // value for 'certifiedPayroll'
 *      industry: // value for 'industry'
 *      serviceDescription: // value for 'serviceDescription'
 *   },
 * });
 */
export function useProjectSearchQuery(baseOptions?: Apollo.QueryHookOptions<ProjectSearchQuery, ProjectSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectSearchQuery, ProjectSearchQueryVariables>(ProjectSearchDocument, options);
      }
export function useProjectSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectSearchQuery, ProjectSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectSearchQuery, ProjectSearchQueryVariables>(ProjectSearchDocument, options);
        }
export type ProjectSearchQueryHookResult = ReturnType<typeof useProjectSearchQuery>;
export type ProjectSearchLazyQueryHookResult = ReturnType<typeof useProjectSearchLazyQuery>;
export type ProjectSearchQueryResult = Apollo.QueryResult<ProjectSearchQuery, ProjectSearchQueryVariables>;
export const ProjectSearchWithStatsDocument = gql`
    query ProjectSearchWithStats($asOf: LocalDate, $searchText: String, $projectNumbers: [Int!], $token: String, $billingAdmin: String, $projectManager: String, $projectSupervisor: String, $officeCode: String, $customerNumber: String, $projectType: String, $division: String, $corpLocation: String, $dateInEqual: LocalDate, $dateInBefore: LocalDate, $dateInAfter: LocalDate, $state: String, $county: String, $afeWoPo: String, $status: ProjectSearchStatus, $clientContactName: String, $sortBy: ProjectSortBy, $projectGroupArgs: ProjectGroupArgsInput, $certifiedPayroll: Boolean, $industry: String, $serviceDescription: String) {
  projects {
    search(
      asOf: $asOf
      searchText: $searchText
      projectNumbers: $projectNumbers
      token: $token
      billingAdmin: $billingAdmin
      projectManager: $projectManager
      projectSupervisor: $projectSupervisor
      officeCode: $officeCode
      customerNumber: $customerNumber
      projectType: $projectType
      division: $division
      corpLocation: $corpLocation
      dateInEqual: $dateInEqual
      dateInBefore: $dateInBefore
      dateInAfter: $dateInAfter
      state: $state
      county: $county
      afeWoPo: $afeWoPo
      status: $status
      clientContactName: $clientContactName
      sortBy: $sortBy
      projectGroupArgs: $projectGroupArgs
      certifiedPayroll: $certifiedPayroll
      industry: $industry
      serviceDescription: $serviceDescription
    ) {
      token
      records {
        name
        number
        clientContactName
        customer {
          name
          number
        }
        actualStartDate
        actualEndDate
        stats {
          chargesAwaitingApproval
          chargesBilled
          chargesPendingBilling
          chargesUnbilled
          chargesUnreviewed
          totalPendingHours
        }
        expenseRateSheets {
          rateSheet {
            name
          }
          effectiveDate
        }
        taskRateSheets {
          rateSheet {
            name
          }
          effectiveDate
        }
        officeCode
        clientContactName
        projectSupervisor {
          firstName
          lastName
        }
        projectManager {
          firstName
          lastName
        }
        billingAdmin {
          firstName
          lastName
        }
        estimatedStartDate
        estimatedEndDate
        corpLocation {
          name
          id
        }
        division {
          id
          name
        }
        serviceDescription {
          displayName
          industry
          description
          projectType
          isOverhead
          legacyWorkCode
        }
        governmentFunding
        location {
          state
          county
        }
        afe
        eogAfeType {
          gen
          sub
          description
          afeType
        }
        budget
        section
        township
        range
        block
        survey
        internalNotes
        invoiceNotes
        geographicLocation
        dateIn
        status
        certifiedPayroll
        projectGroup {
          name
        }
        projectOrigination
        projectOriginationName
      }
    }
    stats(
      asOf: $asOf
      searchText: $searchText
      projectNumbers: $projectNumbers
      token: $token
      billingAdmin: $billingAdmin
      projectManager: $projectManager
      projectSupervisor: $projectSupervisor
      officeCode: $officeCode
      customerNumber: $customerNumber
      projectType: $projectType
      division: $division
      corpLocation: $corpLocation
      dateInEqual: $dateInEqual
      dateInBefore: $dateInBefore
      dateInAfter: $dateInAfter
      state: $state
      county: $county
      afeWoPo: $afeWoPo
      status: $status
      clientContactName: $clientContactName
      sortBy: $sortBy
      projectGroupArgs: $projectGroupArgs
      certifiedPayroll: $certifiedPayroll
      industry: $industry
      serviceDescription: $serviceDescription
    ) {
      projectCount
    }
  }
}
    `;

/**
 * __useProjectSearchWithStatsQuery__
 *
 * To run a query within a React component, call `useProjectSearchWithStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSearchWithStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectSearchWithStatsQuery({
 *   variables: {
 *      asOf: // value for 'asOf'
 *      searchText: // value for 'searchText'
 *      projectNumbers: // value for 'projectNumbers'
 *      token: // value for 'token'
 *      billingAdmin: // value for 'billingAdmin'
 *      projectManager: // value for 'projectManager'
 *      projectSupervisor: // value for 'projectSupervisor'
 *      officeCode: // value for 'officeCode'
 *      customerNumber: // value for 'customerNumber'
 *      projectType: // value for 'projectType'
 *      division: // value for 'division'
 *      corpLocation: // value for 'corpLocation'
 *      dateInEqual: // value for 'dateInEqual'
 *      dateInBefore: // value for 'dateInBefore'
 *      dateInAfter: // value for 'dateInAfter'
 *      state: // value for 'state'
 *      county: // value for 'county'
 *      afeWoPo: // value for 'afeWoPo'
 *      status: // value for 'status'
 *      clientContactName: // value for 'clientContactName'
 *      sortBy: // value for 'sortBy'
 *      projectGroupArgs: // value for 'projectGroupArgs'
 *      certifiedPayroll: // value for 'certifiedPayroll'
 *      industry: // value for 'industry'
 *      serviceDescription: // value for 'serviceDescription'
 *   },
 * });
 */
export function useProjectSearchWithStatsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectSearchWithStatsQuery, ProjectSearchWithStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectSearchWithStatsQuery, ProjectSearchWithStatsQueryVariables>(ProjectSearchWithStatsDocument, options);
      }
export function useProjectSearchWithStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectSearchWithStatsQuery, ProjectSearchWithStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectSearchWithStatsQuery, ProjectSearchWithStatsQueryVariables>(ProjectSearchWithStatsDocument, options);
        }
export type ProjectSearchWithStatsQueryHookResult = ReturnType<typeof useProjectSearchWithStatsQuery>;
export type ProjectSearchWithStatsLazyQueryHookResult = ReturnType<typeof useProjectSearchWithStatsLazyQuery>;
export type ProjectSearchWithStatsQueryResult = Apollo.QueryResult<ProjectSearchWithStatsQuery, ProjectSearchWithStatsQueryVariables>;